import React, {Component} from "react";
import HeaderNavBar from "../components/navigation/HeaderNavbar";


class HomePage extends Component{
    render(){
        return (
            <div>
                <HeaderNavBar></HeaderNavBar>
            </div>
        )
    }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/pages/HomePage.js